import Vue from 'vue'
import SelectAddPatient from './index.vue'

Vue.component('SelectAddPatient', SelectAddPatient)



// WEBPACK FOOTER //
// ./src/components/selectAddPatient/load.js